import { useCallback, useEffect, useRef, useState } from 'react';
import { useAudienceTray } from '../providers/audience-tray-provider';

export const useSplitSelectionList = (selectedItemsCount: number) => {
  const { mode } = useAudienceTray();
  const [selectedContactsBinHeight, setSelectedContactsBinHeight] = useState<number>();
  const [unselectedContactsBinHeight, setUnselectedContactsBinHeight] = useState<number>();
  const [showSelectedBinPreference, setShowSelectedBinUserPref] = useState(true);

  const toggleSelectedUsersBin = useCallback(() => {
    setShowSelectedBinUserPref(!showSelectedBinPreference);
  }, [setShowSelectedBinUserPref, showSelectedBinPreference]);

  const showSelectedBinToggle = selectedItemsCount > 0;
  const showSelectedBin = showSelectedBinToggle && showSelectedBinPreference;

  const headerRef = useRef<HTMLDivElement>(null);
  const bodyRef = useRef<HTMLDivElement>(null);

  const handleResize = useCallback(() => {
    if (!bodyRef.current) return;
    const headerHeight = headerRef.current?.clientHeight ?? 0;
    const bodyHeight = bodyRef.current.clientHeight;
    const selectedBorderWidth = 2;
    const gap = 16;
    const unselectedHeight = showSelectedBin ? Math.round(bodyHeight / 2) : bodyHeight;
    const selectedHeight = bodyHeight - unselectedHeight - headerHeight - selectedBorderWidth - gap;
    setUnselectedContactsBinHeight(Math.max(0, unselectedHeight));
    setSelectedContactsBinHeight(Math.max(0, selectedHeight));
  }, [showSelectedBin]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    setTimeout(handleResize); // This setTimeout magically makes things render correctly. Without it, the selected or unselected recipients lists sometimes end up being 0 height.
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize, showSelectedBin, mode]); // The mode must be included in the dependency array to ensure heights are recalculated when the view changes

  return {
    bodyRef,
    headerRef,
    selectedContactsBinHeight,
    showSelectedBin,
    showSelectedBinPreference,
    showSelectedBinToggle,
    toggleSelectedUsersBin,
    unselectedContactsBinHeight,
  };
};
